<template>
  <div class="mains">
    <div class="campus">
      功能模块
      <span>></span>
      <span @click="testingear0">单词训练</span>
      <span>></span>
      <router-link to>上传闪卡</router-link>
    </div>
    <div class="xiaoqu">
      <el-card :span="24">
        <div class="grid-content">
          <el-dialog class="yl_shanka" title="预览闪卡" :visible.sync="addStudents">
            <div class="form_1 form_1_1 yulan_0list scrollbarStyle">
              <div class="yulan_name">
                {{ yl_name }}
                <span>（ 单词数：{{ yl_name_dc }} 词 ）</span>
              </div>
              <div v-for="(item, index) in yulan_list" :key="index">
                <div class="yl_xunxu">{{ index + 1 }}.</div>
                <div class="yl_neirong">
                  <div>单词： {{ item.english }}</div>
                  <div>翻译： {{ item.chinese }}</div>
                  <div>
                    <img :src="item.picurl" alt="" />
                  </div>
                </div>
              </div>
            </div>
          </el-dialog>
        </div>

        <div class="xiaoqu_1">上传闪卡</div>
        <div class="shenzhong">
          <i class="img_1"> <img src="@/assets/img/education-manage/campus/shenzhong.png" alt /> </i>
          您所上传制作的闪卡练习可直接进行单词及图片、音频的上传。
        </div>
        <div class="form_1 kbfm">
          <el-form ref="forms" :model="form" :rules="FormRules" label-width="5.20833vw">
            <el-form-item label="名称" prop="name">
              <i>
                <img src="@/assets/img/education-manage/campus/bitian.png" class="lianzi1" alt />
              </i>
              <el-input v-model="form.name" placeholder="请输入校区名称 ( 不超过12字 )" :disabled="this.show" @blur="blur" @keyup.enter.native="$event.target.blur"></el-input>
              <div class="shangchuan_yinyue">
                <el-button type="primary" class="my-10" @click="updateChapter1">
                  重命名
                </el-button>
              </div>
            </el-form-item>
            <el-form-item label="顺序" prop="seqnum">
              <i>
                <img src="@/assets/img/education-manage/campus/bitian.png" class="lianzi1" alt />
              </i>
              <el-input v-model="form.seqnum" placeholder="请输入顺序 ( 阿拉伯数字 )" :disabled="this.show1" @blur="blur_seq" @keyup.enter.native="$event.target.blur"></el-input>
              <div class="shangchuan_yinyue">
                <el-button type="primary" class="my-10" @click="updateChapter2">
                  重置
                </el-button>
              </div>
            </el-form-item>
            <el-form-item label="上传闪卡" class="shangchuan_bg1" prop="orgcode">
              <i>
                <img src="@/assets/img/education-manage/campus/bitian.png" alt />
              </i>
              <el-input v-model="form.orgcode" placeholder="请输入您上传的闪卡名称" @keyup.enter.native="daoru_add"></el-input>
              <div class="shangchuan_yinyue">
                <el-button type="primary" class="my-10" @click="daoru_add">
                  制作闪卡
                </el-button>
              </div>
            </el-form-item>

            <el-form-item label prop="orgcode" class="shangchuan_bg">
              <div class="grid-content">
                <div class="zsbg">
                  <el-table :data="tableData" border style="width: 62.8125vw">
                    <el-table-column prop="title" label="闪卡名称">
                      <template slot-scope="scope1">
                        <!-- {{ scope1.row }} -->
                        <input type="text" class="yp_name" :class="scope1.row.selected ? 'yp_name2' : 'yp_name1'" v-model="scope1.row.title" :disabled="scope1.row.selected" :id="scope1.row.selected ? '' : 'inputId'"
                          @blur="blur1(scope1.$index, tableData)" @keyup.13="blur1(scope1.$index, tableData)" />
                      </template>
                    </el-table-column>
                    <el-table-column label="闪卡排序">
                      <template slot-scope="scopes">
                        <el-input v-model="scopes.row.seqnum" class="yp_paixu" @blur="blur1(scopes.$index, tableData)" @keyup.enter.native="
                            $event.target.blur(scopes.$index, tableData)
                          "></el-input>
                      </template>
                    </el-table-column>

                    <el-table-column label="操作">
                      <template slot-scope="stData">
                        <el-button type="text" @click="chong(stData.$index, tableData)">
                          重命名
                        </el-button>
                        <el-button type="text" @click="zhizuo_py(stData.row.id)">
                          新建
                        </el-button>
                        <el-button type="text" @click="zhizuo_py1(stData.row.id)">
                          修改
                        </el-button>
                        <el-button type="text" @click="deleteWordPractice(stData.row.id)">
                          删除
                        </el-button>
                        <el-button type="text" @click="yulan(stData.row.id)">
                          预览
                        </el-button>
                      </template>
                    </el-table-column>
                  </el-table>
                </div>
              </div>
            </el-form-item>
          </el-form>
        </div>
      </el-card>
    </div>
  </div>
</template>

<script>
export default {
  name: 'testingear',
  data() {
    return {
      form: {
        name: '',
        orgcode: '',
        seqnum: '',
      },
      FormRules: {},
      yl_name: '',
      yl_name_dc: '',
      show: true,
      show1: true,
      tempImg: '',
      banji_id: {},
      tableData: [],
      gh_yp: '',
      addStudents: false,
      yulan_list: [],
    };
  },
  created() {
    if (!this.$store.state.testing) {
      this.$router.push({ name: 'testing' });
      return this.$message.error('您当前的章节数据获取失败！');
    }
    this.banji_id = this.$store.state.testing;

    this.selectWordPractice();
    this.selctChapterandsectionById();
  },
  destroyed() {
    localStorage.removeItem('testing');
  },
  watch: {},
  methods: {
    testingear0() {
      this.$store.commit('testingear0', this.banji_id.bookid);
      this.$router.push({ name: 'testing' });
    },

    zhizuo_py(testingear) {
      let token = window.sessionStorage.getItem('userinfo').replace(/"/g, '');
      // let orgid = window.sessionStorage.getItem('orgid')
      let pro = this.$http({
        url: '/edu/wordpractice/getWordPracticeViewById/' + testingear,
        method: 'GET',
        headers: {
          Authorization: 'Bearer ' + token,
        },
      });
      pro
        .then((result) => {
          // console.log(result)
          if (result.data.code !== 0) {
            return this.$message.error(result.data.message);
          }
          if (result.data.data.length === 0) {
            this.$store.commit('testingear', testingear);
            this.$store.commit('testingears', this.banji_id);
            this.$router.push({ name: 'testingDubList' });
          } else {
            return this.$message.error('您的闪卡已有数据！');
          }
        })
        .catch((err) => {
          // console.log(err)
          return this.$message.error('新建闪卡失败：' + err);
        });
    },

    zhizuo_py1(testingear) {
      this.$store.commit('testingear1', testingear);
      this.$store.commit('testingearbs', this.banji_id);
      this.$router.push({ name: 'testingupdate' });
    },

    yulan(id) {
      let token = window.sessionStorage.getItem('userinfo').replace(/"/g, '');
      // let orgid = window.sessionStorage.getItem('orgid')
      let pro = this.$http({
        url: '/edu/wordpractice/getWordPracticeViewById/' + id,
        method: 'GET',
        headers: {
          Authorization: 'Bearer ' + token,
        },
      });
      pro
        .then((result) => {
          // console.log(result)
          if (result.data.code !== 0) {
            return this.$message.error(result.data.message);
          }
          this.yulan_list = result.data.data;
          for (var i = 0; i < this.tableData.length; i++) {
            if (this.tableData[i].id === id) {
              this.yl_name = this.tableData[i].title;
            }
          }
          this.yl_name_dc = result.data.data.length;
          if (result.data.data.length !== 0) {
            this.addStudents = true;
          } else {
            return this.$message.error('您的闪卡当前没有数据！');
          }
        })
        .catch((err) => {
          // console.log(err)
          return this.$message.error('预览闪卡失败：' + err);
        });
    },

    // 章节重命名
    updateChapter1() {
      this.show = false;
    },
    updateChapter2() {
      this.show1 = false;
    },
    blur() {
      this.show = true;
      let token = window.sessionStorage.getItem('userinfo').replace(/"/g, '');
      // let orgid = window.sessionStorage.getItem('orgid')
      let pro = this.$http({
        url: '/edu/chapterandsection/updateChapter',
        method: 'POST',
        data: {
          id: this.banji_id.id,
          title: this.form.name,
        },
        headers: {
          Authorization: 'Bearer ' + token,
        },
      });
      pro
        .then((result) => {
          // console.log(result)
          if (result.data.code !== 0) {
            return this.$message.error(result.data.message);
          }
          return this.$message.success('章节重命名成功！');
        })
        .catch((err) => {
          // console.log(err)
          return this.$message.error('章节重命名失败：' + err);
        });
    },
    blur_seq() {
      this.show1 = true;
      let token = window.sessionStorage.getItem('userinfo').replace(/"/g, '');
      // let orgid = window.sessionStorage.getItem('orgid')
      let pro = this.$http({
        url: '/edu/chapterandsection/updateChapter',
        method: 'POST',
        data: {
          id: this.banji_id.id,
          seqnum: this.form.seqnum,
        },
        headers: {
          Authorization: 'Bearer ' + token,
        },
      });
      pro
        .then((result) => {
          // console.log(result)
          if (result.data.code !== 0) {
            return this.$message.error(result.data.message);
          }
          return this.$message.success('序号重置成功！');
        })
        .catch((err) => {
          // console.log(err)
          return this.$message.error('序号重置失败：' + err);
        });
    },
    // 闪卡重命名
    chong(index, rows) {
      // console.log(index)
      // console.log(rows)
      // console.log(rows[index])
      rows[index].selected = false;
      document.getElementById('inputId').focus();
    },

    blur1(index, rows) {
      // console.log(rows[index])
      rows[index].selected = true;

      let token = window.sessionStorage.getItem('userinfo').replace(/"/g, '');
      // let orgid = window.sessionStorage.getItem('orgid')
      let pro = this.$http({
        url: '/edu/wordpractice/updateWordPractice',
        method: 'POST',
        data: {
          id: rows[index].id,
          title: rows[index].title,
          seqnum: rows[index].seqnum,
        },
        headers: {
          Authorization: 'Bearer ' + token,
        },
      });
      pro
        .then((result) => {
          // console.log(result)
          if (result.data.code !== 0) {
            return this.$message.error(result.data.message);
          }
          this.selectWordPractice();
          return this.$message.success('闪卡修改成功！');
        })
        .catch((err) => {
          // console.log(err)
          return this.$message.error('闪卡修改失败：' + err);
        });
    },

    // 制作闪卡
    daoru_add() {
      let token = window.sessionStorage.getItem('userinfo').replace(/"/g, '');
      let orgid = window.sessionStorage.getItem('orgid');
      if (this.form.orgcode === '') {
        return this.$message.error('请首先输入该闪卡的名称！');
      }
      let pro = this.$http({
        url: '/edu/wordpractice/addWordPractice',
        method: 'POST',
        data: {
          title: this.form.orgcode,
          chapterid: this.banji_id.id,
          bookid: this.banji_id.bookid,
          orgid: orgid,
        },
        headers: {
          Authorization: 'Bearer ' + token,
        },
      });
      pro
        .then((result) => {
          // console.log(result)
          if (result.data.code !== 0) {
            return this.$message.error(result.data.message);
          }
          this.form.orgcode = '';
          this.selectWordPractice();
          return this.$message.success('制作闪卡成功!');
        })
        .catch((err) => {
          // console.log(err)
          return this.$message.error('制作闪卡失败：' + err);
        });
    },

    // 更改闪卡
    genghuan(id) {
      // console.log(id)
      this.gh_yp = id;
    },

    // 删除闪卡
    deleteWordPractice(id) {
      let token = window.sessionStorage.getItem('userinfo').replace(/"/g, '');
      this.$confirm('确认要删除吗?', '删除', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning',
      }).then(() => {
        // axios请求服务器端实现删除
        let pro = this.$http({
          url: '/edu/wordpractice/deleteWordPractice/' + id,
          method: 'POST',
          headers: {
            Authorization: 'Bearer ' + token,
          },
        });
        pro
          .then((result) => {
            // console.log(result)
            if (result.data.code !== 0) {
              return this.$message.error(result.data.message);
            }
            this.selectWordPractice();
            return this.$message.success('删除闪卡成功!');
          })
          .catch((err) => {
            // console.log(err)
            return this.$message.error('删除闪卡失败：' + err);
          });
      });
    },

    // 查询章节名称
    selctChapterandsectionById() {
      let token = window.sessionStorage.getItem('userinfo').replace(/"/g, '');
      let pro = this.$http({
        url: '/edu/chapterandsection/selctChapterandsectionById/' + this.banji_id.id,
        method: 'GET',
        headers: {
          Authorization: 'Bearer ' + token,
        },
      });
      pro
        .then((result) => {
          // console.log(result)
          if (result.data.code !== 0) {
            return this.$message.error(result.data.message);
          }
          this.form.name = result.data.data.title;
          this.form.seqnum = result.data.data.seqnum;
        })
        .catch((err) => {
          // console.log(err)
          return this.$message.error('查询章节名称失败：' + err);
        });
    },

    // 查询闪卡
    selectWordPractice() {
      let token = window.sessionStorage.getItem('userinfo').replace(/"/g, '');
      let orgid = window.sessionStorage.getItem('orgid');
      let pro = this.$http({
        url: '/edu/wordpractice/selectWordPractice',
        method: 'POST',
        data: {
          bookid: this.banji_id.bookid,
          chapterid: this.banji_id.id,
          orgid: orgid,
        },
        headers: {
          Authorization: 'Bearer ' + token,
        },
      });
      pro
        .then((result) => {
          // console.log(result.data.data)
          if (result.data.code !== 0) {
            return this.$message.error(result.data.message);
          }
          this.tableData = result.data.data;
          for (var i = 0; i < this.tableData.length; i++) {
            this.tableData[i].selected = true;
          }
        })
        .catch((err) => {
          // console.log(err)
          return this.$message.error('查询闪卡列表失败：' + err);
        });
    },
  },
};
</script>

<style lang="less" scoped>

</style>
